<script setup>
import { ref } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import KnowledgeBaseForm from './KnowledgeBaseForm.vue';

const emit = defineEmits(['close', 'created']);
const { t } = useI18n();
const store = useStore();

const dialogRef = ref(null);
const knowledgeBaseForm = ref(null);

const createKnowledgeBase = async knowledgeBaseDetails => {
  try {
    const response = await store.dispatch(
      'pilotKnowledgeBases/create',
      knowledgeBaseDetails
    );
    useAlert(t('PILOT.KNOWLEDGE_BASES.CREATE.SUCCESS_MESSAGE'));
    dialogRef.value.close();
    emit('created', response.payload || response);
  } catch (error) {
    const errorMessage =
      error?.message || t('PILOT.KNOWLEDGE_BASES.CREATE.ERROR_MESSAGE');
    useAlert(errorMessage);
  }
};

const handleSubmit = async knowledgeBaseDetails => {
  await createKnowledgeBase(knowledgeBaseDetails);
};

const handleClose = () => {
  emit('close');
};

const handleCancel = () => {
  dialogRef.value.close();
};

const open = () => {
  // 重置表单状态
  knowledgeBaseForm.value?.resetForm();
  dialogRef.value?.open();
};

defineExpose({ dialogRef, open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    :title="t('PILOT.KNOWLEDGE_BASES.CREATE.TITLE')"
    :show-cancel-button="false"
    :show-confirm-button="false"
    overflow-y-auto
    @close="handleClose"
  >
    <KnowledgeBaseForm
      ref="knowledgeBaseForm"
      @submit="handleSubmit"
      @cancel="handleCancel"
    />
    <template #footer />
  </Dialog>
</template>
